import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { BlogService } from "../Shared/blog.service";
import { INewsletter } from "../Shared/IBlog";

@Component({
  selector: "app-blog",
  templateUrl: "./blog.component.html",
  styleUrls: ["./blog.component.scss"],
})
export class BlogComponent implements OnInit {
  constructor(public blogService: BlogService, private msg: ToastrService) {}
  loading = false;

  newsLetters: INewsletter[] = [];
  filteredNewsLetters: INewsletter[] = [];
  defaultTypeId = 1;
  type = 1;

  

  ngOnInit(): void {
    this.getDisplayedNewsletters();
   

  }

  dateDisplay(date){
    // {{new Date(elm.newsletterDate).toLocaleDateString("en-uk", {year: 'numeric', month: 'long', day: '2-digit'})}}
    return new Date(date).toLocaleDateString("en-uk", {year: 'numeric', month: 'long', day: '2-digit'});
  }


  getDisplayedNewsletters() {
    this.loading = true;
    this.blogService.getDisplayedNewsletters().subscribe(response => {
      console.log('Types ', response);
      if (response.errorOccured) {
        this.msg.error(response.errorMessage);
      }
      else if(response.result) {
        // this.newsLetters = response.result;
        this.newsLetters = response.result;
        this.newsLetters=this.newsLetters.sort((a,b)=>a.sortedNumber-b.sortedNumber)
        // this.filteredNewsLetters = this.newsLetters;
        this.filteredNewsLetters = this.newsLetters.filter(r => r.newsletterTypeID == this.defaultTypeId);

        console.log('newsLetters ', this.newsLetters);
        console.log('newsLetters ', this.filteredNewsLetters);
      }
      this.loading = false;
    },
      (err: HttpErrorResponse) => {
        this.loading = false;
        // console.log('error');
        // console.log(err);
        if (err.status === 400) {
          this.msg.error(err.error);
          // console.log('Error');
        } else if (err.status === 503) {
          this.msg.error(err.error);
        } else {
          this.msg.info('Unable To Access Server, Please refresh the page and try again');
        }

      });
  }

  changeFilter(type) {
    this.type=type;
      this.filteredNewsLetters = this.newsLetters.filter(
        (x) => x.newsletterTypeID  == type
      );

  }
}
